<template>
    <v-container>
        <HeadbarPage
            :title="'Títulos > Manutenção de Devedor/Codevedor'"
        ></HeadbarPage>

        <v-card class="mt-2 mb-3">
            <v-tabs v-model="activeTab" color="primary" grow>
                <v-tab>
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    Consulta e Download de Modelo
                </v-tab>
                <v-tab>
                    <v-icon class="mr-2">mdi-upload</v-icon>
                    Upload e Pré-visualização
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <ConsultaDownloadModelo
                                ref="consultaDownloadModelo"
                                @titulos-selecionados="onTitulosSelecionados"
                                @download-modelo="downloadModelo"
                                @show-error="showError"
                            />
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <UploadPreVisualizacao
                                :titulos-selecionados="titulosSelecionados"
                                @show-success="showSuccess"
                                @show-error="showError"
                                @refazer-busca="refazerBuscaTitulos"
                            />
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <Snackbar
            v-if="snackbar"
            :mostrarSnackbar="snackbar"
            :corSnackbar="colorSnackbar"
            :mensagemSnackbar="mensagemSnackbar"
            @fecharSnackbar="snackbar = false"
        />
    </v-container>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
    name: 'ManutencaoDevedorCoodevedor',
    components: {
        HeadbarPage: () => import('@/components/atoms/HeadbarPage'),
        ConsultaDownloadModelo: () =>
            import('@/components/organisms/ConsultaDownloadModelo'),
        UploadPreVisualizacao: () =>
            import('@/components/organisms/UploadPreVisualizacao'),
        Snackbar: () => import('@/components/Snackbar')
    },
    data() {
        return {
            activeTab: 0,
            titulosSelecionados: [],
            snackbar: false,
            colorSnackbar: '',
            mensagemSnackbar: ''
        };
    },
    methods: {
        onTitulosSelecionados(titulos) {
            this.titulosSelecionados = titulos;
        },

        downloadModelo() {
            if (this.titulosSelecionados.length === 0) {
                this.showError(
                    'Selecione pelo menos um título para gerar o modelo.'
                );
                return;
            }

            const dadosModelo = [
                [
                    'Número Título',
                    'Nome',
                    'CPF/CNPJ',
                    'Tipo',
                    'Endereço',
                    'CEP',
                    'Cidade',
                    'UF',
                    'Telefone',
                    'Email'
                ]
            ];

            this.titulosSelecionados.forEach(() => {
                dadosModelo.push([
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]);
            });

            try {
                const ws = XLSX.utils.aoa_to_sheet(dadosModelo);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Modelo Devedores');

                XLSX.writeFile(
                    wb,
                    `modelo_devedores_${new Date()
                        .toISOString()
                        .slice(0, 10)}.xlsx`
                );

                this.showSuccess('Modelo baixado com sucesso!');
            } catch (error) {
                console.error('Erro ao gerar modelo:', error);
                this.showError('Erro ao gerar modelo. Tente novamente.');
            }
        },

        showSuccess(message) {
            this.mensagemSnackbar = message;
            this.colorSnackbar = 'success';
            this.snackbar = true;
        },

        showError(message) {
            this.mensagemSnackbar = message;
            this.colorSnackbar = 'error';
            this.snackbar = true;
        },

        showSnackbar(message, color = 'success') {
            this.mensagemSnackbar = message;
            this.colorSnackbar = color;
            this.snackbar = true;
        },

        refazerBuscaTitulos() {
            this.activeTab = 0; // Mudar para a aba de consulta
            this.$nextTick(() => {
                if (this.$refs.consultaDownloadModelo) {
                    this.$refs.consultaDownloadModelo.refazerBusca();
                }
            });
        }
    }
};
</script>

<style scoped>
.v-tabs {
    border-bottom: 1px solid #e0e0e0;
}
</style>
